export default __webpack_public_path__ + "static/card-img02-c2c225b499e7ea8adb674c3fb368d2fe.jpg";